import React from 'react';
import { Navigate } from 'react-router-dom';

// ProtectedRoute checks if the user is authenticated and if not redirects them to the login page.
const DealerProtectedRoute = ({ element }) => {
  const isAuthenticated = Boolean(sessionStorage.getItem('authTokenDealer'));

  return isAuthenticated ? element : <Navigate to="/Logistics/Login" />;
};

export default DealerProtectedRoute;
